import { UserRepository } from "../../../api";
import { Report } from "./Report";

export class MenagementReport extends Report {

	constructor(obj = {}) {
		super();
		
		// SUPER this.points = [];
		// SUPER this.colors = [];
		// SUPER this.labels = [];
		
		this.governanceResponsibilitiesPoints = obj.governanceResponsibilitiesPoints || {};
		this.businessPlanningPoints = obj.businessPlanningPoints || {};
	
		this.active = false;

		this.setColors();
		this.setPoints();
		this.setLabels();

	}

	setColors() {

		const governanceArray 	= Object.keys(this.governanceResponsibilitiesPoints);
		const businessArray 		= Object.keys(this.businessPlanningPoints);

		const governanceColors = governanceArray.map(i => {
			return this.getColor(this.governanceResponsibilitiesPoints[i]);
		});

		const businessColors = businessArray.map(i => {
			return this.getColor(this.businessPlanningPoints[i]);
		});

		this.colors = this.compilateArray({governanceColors, businessColors});
	}

	setPoints() {

		const governanceArray 	= Object.keys(this.governanceResponsibilitiesPoints);
		const businessArray 		= Object.keys(this.businessPlanningPoints);

		const governancePoints = governanceArray.map(i => {
			return this.getPoints(this.governanceResponsibilitiesPoints[i]);
		});

		const businessPoints = businessArray.map(i => {
			return this.getPoints(this.businessPlanningPoints[i]);
		});

		this.points = this.compilateArray({governancePoints, businessPoints});
	}

	setLabels() {
		const governanceArray 	= Object.keys(this.governanceResponsibilitiesPoints);
		const businessArray 		= Object.keys(this.businessPlanningPoints);

		const allItems = this.compilateArray({governanceArray, businessArray});

		this.labels = allItems.map(i => {
			switch(i) {
				case "2-1" : return "Envolvimento da alta administração";
				case "2-2" : return "Existência de comitê de água";
				case "2-3" : return "Participação em programas de gestão";
				case "2-4" : return "Mitigação de impactos";
				case "2-5" : return "Gestão de riscos e oportunidades";
			}
		});
	}

	generateChart(id) {
		this.generateReport(id, this.colors, this.points, this.labels);
	}
	
	init(auth, id) {
		return {
			colors: this.colors,
			points: this.points,
			labels: this.labels,
			active: false
		};
	}
		
}


// WEBPACK FOOTER //
// src/models/lib/entities/MenagementReport.js